export default __webpack_public_path__ + "static/fa-solid-900-9bbb245e67a133f6e486d8d2545e14a5.eot";